// extracted by mini-css-extract-plugin
export default {"page":"App_page__nt1Vd"};